import { render } from "./CommentsComponent.vue?vue&type=template&id=45dcd7d0&scoped=true&ts=true"
import script from "./CommentsComponent.vue?vue&type=script&lang=ts"
export * from "./CommentsComponent.vue?vue&type=script&lang=ts"

import "./CommentsComponent.vue?vue&type=style&index=0&id=45dcd7d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dcd7d0"]])

export default __exports__